import { useEffect, useMemo, useState } from 'react';
import { Button, ContentfulComponentMap, Flex, Heading, Modal } from '@components';
import styles from './ContentfulModal.module.scss';
import { useTranslation } from '@utils/index';

const getTranslatedTexts = translator => {
	return {
		close: translator('close-uppercase'),
	};
};

const ContentfulModal = ({
	modal,
	openModal = false,
	modalContent,
	buttonContent,
	children,
}: {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	modal: any;
	openModal?: boolean;
	modalContent?: React.ReactNode;
	buttonContent?: React.ReactNode;
	children?: React.ReactNode;
}) => {
	const [isOpen, setIsOpen] = useState(openModal);
	const { translator } = useTranslation();
	const translations = getTranslatedTexts(translator);

	useEffect(() => {
		setIsOpen(openModal);
	}, [openModal]);

	const trigger = useMemo(() => {
		return children || <div style={{ width: '100%', height: '100%' }}>{buttonContent}</div>;
	}, [children, buttonContent]);

	if (!modal) return null;

	const title = modal.title ?? modal.internalName;

	return (
		<Modal open={isOpen} onOpenChange={setIsOpen}>
			<Modal.Trigger asChild>{trigger}</Modal.Trigger>
			{/*TODO find way to remove hard-coded width*/}
			<Modal.Content removePadding closeButtonSticky style={{ maxWidth: '67.2rem' }}>
				<div className={styles['content']}>
					<div className={styles['header']}>
						<Heading tag='h5'>{title}</Heading>
					</div>
					{modal.content && <ContentfulComponentMap blocks={[modal.content]} />}
					{modalContent}
				</div>
				{modal.displayCloseButton || (modal.buttonLink && modal.buttonLabel) ? (
					<Flex gap={3} className={styles['buttons']}>
						{modal.displayCloseButton && (
							<Button color='white' onClick={() => setIsOpen(false)}>
								{translations.close}
							</Button>
						)}
						{modal.buttonLink && modal.buttonLabel && (
							<Button fullWidth href={modal.buttonLink}>
								{modal.buttonLabel}
							</Button>
						)}
					</Flex>
				) : null}
			</Modal.Content>
		</Modal>
	);
};

export default ContentfulModal;
